/**
 * 文本颜色动画
 */
import fvAnimation from "./fvAnimation"
export default class fvTextColor extends fvAnimation {
    constructor(shape){
        super(shape,"fvTextColor");
        this.colorOldColor = this.shape.color;
        this.sizeFunction = AsyncFunction("return " + this.expression);
    }

    async run(svgColorDom,value){
        if(value == false) return;
        var size = await this.executionScript(this.sizeFunction);
        for(var i in this.changeColor){
            if(this.changeColor[i].Twinkel == true){
                if(this.shape.color == this.colorOldColor){
                    this.shape.color = this.changeColor[i].TwinkelColor ;
                }
                else{
                    this.shape.color = this.colorOldColor ;
                }
            }else{
                if(size >= this.changeColor[i].MinValue && size <= this.changeColor[i].MaxValue){
                    this.shape.color = this.changeColor[i].FlashingColor;
                }
            }
        }
        if(this.shape.fctype==="fvButtonObj"){
            this.shape.borderColor=this.shape.color;
            svgColorDom.parentNode.getElementById(this.shape.registerName).innerHTML=`
            <stop offset="0" stop-color="rgba(0,0,0,0)" fill-opacity="0">
            </stop><stop offset="0.012" stop-color="${this.shape.borderColor}" fill-opacity="1">
            </stop><stop offset="1" stop-color="${this.shape.borderColor}" fill-opacity="1">
            </stop>
            `
            svgColorDom.style.fill=`url(#${this.shape.registerName})`

        }else{
            if(svgColorDom.lastElementChild){
                svgColorDom.lastElementChild.style.fill=this.shape.color;
            }else{
                svgColorDom.style.fill=this.shape.color;
            }
            
        }
       
    }
}


// WEBPACK FOOTER //
// ./src/js/div/animationDiv/fvTextColor.js